import { render, staticRenderFns } from "./CartChoose.vue?vue&type=template&id=2da9baec&"
import script from "./CartChoose.vue?vue&type=script&lang=js&"
export * from "./CartChoose.vue?vue&type=script&lang=js&"
import style0 from "./CartChoose.vue?vue&type=style&index=0&id=2da9baec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports